import Vue from 'vue';
import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';

export const SET_BUTTON_DROPDOWN = 'SET_BUTTON_DROPDOWN';
export const DELETE_BUTTON_DROPDOWN = 'DELETE_BUTTON_DROPDOWN';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_BUTTON_DROPDOWN](state, { key, value }) {
		Vue.set(state.buttonDropdowns, key, value);
	},
	[DELETE_BUTTON_DROPDOWN](state, { id }) {
		Vue.delete(state.buttonDropdowns, id);
	},
};

export default mutations;
